function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

export { getNodeName as g };
//# sourceMappingURL=getNodeName-B4zdFol3.js.map
